<ng-container ngModelGroup="citationDateGroup" #citationDate="ngModelGroup">
  <app-filter-item [title]="'Citation date'" [value]="dateRange" [clearFilter]="clearFilter">
    <div class="citation-date">
      <div class="citation-date__full-date">
        <mat-form-field appearance="outline" class="citation-date__full-date-from">
          <input matInput
            name="fromDate"
            [matDatepicker]="fromDate"
            [max]="citationDateGroup.toDate || today"
            [ngModel]="citationDateGroup.fromDate"
            (ngModelChange)="onDateChange($event, 'fromDate')"
          >
          <mat-label>From</mat-label>
          <mat-datepicker-toggle matIconSuffix [for]="fromDate"></mat-datepicker-toggle>
          <mat-datepicker #fromDate></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="citation-date__full-date-to">
          <mat-label>To</mat-label>
          <input matInput
            name="toDate"
            [matDatepicker]="toDate"
            [min]="citationDateGroup.fromDate"
            [max]="today"
            [ngModel]="citationDateGroup.toDate"
            (ngModelChange)="onDateChange($event, 'toDate')"
          >
          <mat-datepicker-toggle matIconSuffix [for]="toDate"></mat-datepicker-toggle>
          <mat-datepicker #toDate></mat-datepicker>
        </mat-form-field>
      </div>

      <mat-button-toggle-group [(value)]="selectedDateTimePreset" class="citation-date__date-time-preset">
        <mat-button-toggle *ngFor="let item of dateTimePresetOptions;" (change)="onDateTimePresetChange($event)"
          [value]="item.value">
          {{item.viewValue}}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </app-filter-item>
</ng-container>
